import { createContext, useContext } from 'react'

export const BlockContext = createContext({})

export function useBlockContext() {
  return useContext(BlockContext)
}
